import type { WorkOrderAssignmentRow, WorkOrderAssignmentSelection } from "../../../contract"
import { buildWorkOrderSelectionLabel } from "../../../../../../../../../../../../../_shared/_logic/work-orders-selection"

const normalizeId = (value: unknown) => `${value ?? ""}`.trim()

export const buildWorkOrderSelectionFromCreated = ({
  workOrder,
  row,
}: {
  workOrder: WorkOrder
  row: WorkOrderAssignmentRow
}): WorkOrderAssignmentSelection => {
  const propertyLabel = row.addressLabel || "Unbekannte Liegenschaft"
  const unitLabel = row.unitLabel === "—" ? "" : row.unitLabel

  return {
    id: normalizeId(workOrder.id),
    label: buildWorkOrderSelectionLabel(workOrder),
    workOrder,
    propertyId: normalizeId(workOrder.property_id) || row.propertyId,
    propertyUnitId: normalizeId(workOrder.property_unit_id) || row.propertyUnitId,
    propertyLabel,
    unitLabel,
  }
}
